import {
  FileIconType,
  getFileTypeIconAsHTMLString,
  initializeFileTypeIcons,
} from "@fluentui/react-file-type-icons";

/**
 * Edgio CDN (spoppe-b.azureedge.net) was retired; icons must load from res.cdn.office.net.
 * @see https://github.com/microsoft/fluentui/issues/33612
 */
export const FILE_TYPE_ICONS_CDN =
  "https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/item-types/";

const MIME_TO_EXTENSION = {
  "application/pdf": "pdf",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  "application/vnd.ms-excel": "xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
  "application/vnd.ms-powerpoint": "ppt",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
  "text/plain": "txt",
  "text/csv": "csv",
  "text/html": "html",
  "application/json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/zip": "zip",
  "application/x-zip-compressed": "zip",
  "application/vnd.rar": "rar",
  "application/x-7z-compressed": "7z",
  "image/png": "png",
  "image/jpeg": "jpg",
  "image/gif": "gif",
  "image/webp": "webp",
  "image/svg+xml": "svg",
  "image/bmp": "bmp",
  "audio/mpeg": "mp3",
  "audio/wav": "wav",
  "video/mp4": "mp4",
  "video/quicktime": "mov",
  "video/webm": "webm",
};

const getExtensionFromFileName = (fileName) => {
  const parts = String(fileName || "").split(".");
  if (parts.length < 2) {
    return "";
  }
  return parts.pop().toLowerCase();
};

const getExtensionFromMimeType = (mimeType) => {
  const mime = String(mimeType || "").toLowerCase();
  if (!mime) {
    return "";
  }

  if (MIME_TO_EXTENSION[mime]) {
    return MIME_TO_EXTENSION[mime];
  }

  if (mime.startsWith("image/")) {
    return mime.split("/")[1] || "png";
  }

  if (mime.startsWith("audio/")) {
    return mime.split("/")[1] || "mp3";
  }

  if (mime.startsWith("video/")) {
    return mime.split("/")[1] || "mp4";
  }

  return "";
};

export const resolveFileExtension = (fileName, mimeType) =>
  getExtensionFromFileName(fileName) || getExtensionFromMimeType(mimeType);

const parseIconSrcFromHtml = (html) => {
  if (!html) {
    return null;
  }
  const match = html.match(/src="([^"]+)"/);
  return match?.[1] ?? null;
};

export const getFileTypeIconSrc = (fileName, mimeType, size = 20) => {
  const extension = resolveFileExtension(fileName, mimeType);
  const html = getFileTypeIconAsHTMLString(
    extension
      ? { extension, size, imageFileType: "svg" }
      : { type: FileIconType.genericFile, size, imageFileType: "svg" },
    FILE_TYPE_ICONS_CDN
  );

  return parseIconSrcFromHtml(html);
};

let fileTypeIconsInitialized = false;

export const ensureFileTypeIconsInitialized = () => {
  if (fileTypeIconsInitialized) {
    return;
  }
  initializeFileTypeIcons(FILE_TYPE_ICONS_CDN);
  fileTypeIconsInitialized = true;
};
